<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.CLINICALITEM' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.CLINICALITEM' | translate }}</h3>
        </div>
        <div class="col-lg-4">

        </div>
    </div>

    <form [formGroup]="clinicalItemForm">
        <div class="row m-t-20">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.CATEGORY' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'ENTITY.CATEGORY' | translate }}"
                        [matAutocomplete]="autocategory" [formControl]="clinicalCategoryCtrl" #categoryInput />

                    <mat-autocomplete #autocategory="matAutocomplete" [displayWith]="displayCategory"
                        (optionSelected)="onClinicalCategorySelected($event.option.value)">
                        <mat-option *ngIf="showAddOptionforCategory" class="text-primary"
                            (mousedown)="$event.preventDefault(); addClinicalCategory(categoryInput.value)">
                            <strong>Add "{{ clinicalCategoryCtrl.value }}"</strong>
                        </mat-option>
                        <mat-option *ngFor="let category of filteredclinicalCategory$ | async" [value]="category">
                            {{ category.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.SUBCATEGORY' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'ENTITY.SUBCATEGORY' | translate }}"
                        [matAutocomplete]="autosubcategory" [formControl]="clinicalSubCategoryCtrl" #subcategoryInput />

                    <mat-autocomplete #autosubcategory="matAutocomplete" [displayWith]="displaySubCategory"
                        (optionSelected)="onClinicalSubCategorySelected($event.option.value)">
                        <mat-option *ngIf="showAddOptionforSubCategory" class="text-primary"
                            (mousedown)="$event.preventDefault(); addClinicalSubCategory(subcategoryInput.value,selectedCategoryId)">
                            <strong>Add "{{ clinicalSubCategoryCtrl.value }}"</strong>
                        </mat-option>
                        <mat-option *ngFor="let subcategory of filteredclinicalSubCategory$ | async"
                            [value]="subcategory">
                            {{ subcategory.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DESCRIPTION_LABEL' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.DESCRIPTION_LABEL' | translate }}" cols="5" rows="3"
                        formControlName="description"></textarea>
                    <mat-error *ngIf="clinicalItemForm.get('description')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="clinicalItemForm.get('description')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM255' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ADDITIONALINFO' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.ADDITIONALINFO' | translate }}" cols="5" rows="3"
                        formControlName="additionalInfo"></textarea>
                        <mat-error *ngIf="clinicalItemForm.get('additionalInfo')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM255' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-checkbox class="justify-content-end" [color]="'primary'" formControlName="isSince"></mat-checkbox>
                <span class="f-s-15 f-w-600">{{ 'LABEL.ISSINCE_LABEL' | translate }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-9"></div>
            <div class="col-lg-3 d-flex justify-content-end">
                <button mat-stroked-button (click)="onCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate }}</button>
                <button mat-flat-button color="primary" (click)="onclinicalItemSave()" *ngIf="!isEdit" class="m-l-4"
                    [disabled]="clinicalItemForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>
                <button mat-flat-button color="primary" (click)="onclinicalItemsUpdate()" *ngIf="isEdit" class="m-l-4">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            </div>

        </div>
    </form>
</div>